module.exports = __webpack_public_path__ + "static/media/clock-turn.selected.c4339e5b.svg";